/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import './FeedbackOverlay.css'

export default class FeedbackOverlay extends Component {

    render() {
        const closeClass = this.props.open ? 'opened' : 'closed'
        return (
            <div className={`FeedbackOverlay ${closeClass}`}>
                <div className="wrapper">{this.props.text}</div>
            </div>
        )
    }
}
